import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import OrderFormModal from './OrderFormModal'; // OrderFormModal 컴포넌트 임포트
import { DateTime } from 'luxon';
import Calendar from 'react-calendar';
import Cookies from 'js-cookie';
import 'react-calendar/dist/Calendar.css';

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr); // 4열 레이아웃
  gap: 20px;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #f0f0f0;

  // 768px 이하일 때 레이아웃 변경
  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr; // 2열 레이아웃으로 변경
    grid-gap: 10px; // 간격 줄이기
  }
`;

const Column = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 15px;

  // 768px 이하일 때 열 확장 설정
  @media (max-width: 768px) {
    &:nth-child(1), &:nth-child(2) {
      grid-column: span 1; // 각각 하나의 열 차지
    }

    &:nth-child(3), &:nth-child(4) {
      grid-column: span 2; // 두 번째 행 전체를 차지
    }
  }

  @media (max-width: 425px) {
    grid-column: span 2; // 모든 열이 전체를 차지
  }
`;

const Title = styled.h2`
  font-size: 1.2rem;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
`;

const Select = styled.select`
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
`;

const ButtonList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;

const TimeButton = styled.button`
  padding: 8px 12px;
  background-color: ${(props) => (props.selected ? '#e0e0e0' : 'white')};
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;

const Input = styled.input`
  padding: 8px;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
`;

const Button = styled.button`
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 1rem;
  border-radius: 5px;
  transition: background 0.3s;
  &:hover {
    background: #0056b3;
  }
`;

const SubTitle = styled.h3`
  font-size: 1rem;
  margin-top: 15px;
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px solid #e0e0e0;
`;


// 스타일 컴포넌트 추가
const SelectWrapper = styled.div`
  position: relative;
  margin-bottom: 10px;
`;

const LoadingSpinner = styled.div`
  position: absolute;
  right: 25px;
  top: 40%;
  transform: translateY(-50%);
  width: 15px;
  height: 15px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: translateY(-50%) rotate(0deg); }
    100% { transform: translateY(-50%) rotate(360deg); }
  }
`;

const MovieScheduleFilter = ({ applyCurrentCoupon,couponPrice, setShowScheduleFilter, clearCouponCookie }) => {
  const [movies, setMovies] = useState([]);
  const [regions, setRegions] = useState([]);
  const [subRegions, setSubRegions] = useState([]);
  const [theaters, setTheaters] = useState([]);
  const [dates, setDates] = useState([]);
  const [times, setTimes] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentDate, setCurrentDate] = useState(DateTime.now());
  const [selectedDate, setSelectedDate] = useState(null);
  const [viewerCount, setViewerCount] = useState(1);
  const [amount, setAmount] = useState(0);
  //const couponPrices = JSON.parse(Cookies.get('couponPrices') || '{}');
  const [couponPrices, setCouponPrices] = useState(JSON.parse(Cookies.get('couponPrices') || '{}'));


  // 상단에 state 추가
//const [isLoading, setIsLoading] = useState(false);
// 개별 로딩 상태 추가
const [loadingStates, setLoadingStates] = useState({
  movies: false,
  regions: false,
  subRegions: false,
  theaters: false,
  dates: false,
  times: false
});

  const [filters, setFilters] = useState({
    cinemaBrand: '',
    movieTitle: '',
    region: '',
    subRegion: '',
    theater: '',
    date: '',
    time: '',
    menu_id: '', // menu_id를 추가합니다.
  });
  // applyCurrentCoupon이 변경될 때 viewerCount 업데이트
  useEffect(() => {
    // min_order_cnt가 있으면 해당 값으로 초기화, 없으면 1로 초기화
    const initialViewerCount = applyCurrentCoupon.min_order_cnt || 1;
    setViewerCount(initialViewerCount);

    // 금액도 초기 인원수에 맞게 업데이트
    if (Object.keys(couponPrices).length > 0) {
      const newAmount = couponPrices[`${initialViewerCount}인`] || 0;
      setAmount(newAmount);
    }
  }, [applyCurrentCoupon, couponPrices]);

  useEffect(() => {
    if (filters.time && Object.keys(couponPrices).length > 0) {
      const newAmount = couponPrices[`${viewerCount}인`] || 0;
      setAmount(newAmount);
    }
  }, [viewerCount, couponPrices, filters.time]);
  // API 호출 함수들
  const fetchMovies = async (cinemaBrand) => {
    try {
      setLoadingStates(prev => ({ ...prev, movies: true }));
      const response = await fetch(`/movieschedules/movies?cinemaBrand=${cinemaBrand}`);
      if (!response.ok) throw new Error('영화 데이터를 불러오는 데 실패했습니다.');
      const data = await response.json();
      setMovies(data);  // 백엔드에서 이미 형식이 맞춰진 데이터가 올 것이므로 추가 변환 불필요
    } catch (error) {
      console.error('영화 데이터 가져오기 오류:', error);
    } finally {
      setLoadingStates(prev => ({ ...prev, movies: false }));
    }
};


const fetchRegions = async (movieTitle, cinemaBrand) => {
  try {
    console.log('=================================================');
    console.log('영화관', cinemaBrand);
    console.log('영화제목', movieTitle);
    setLoadingStates(prev => ({ ...prev, regions: true }));
    
    const response = await fetch(
      `/movieschedules/regions?movieTitle=${encodeURIComponent(movieTitle)}&cinemaBrand=${cinemaBrand}`
    );
    if (!response.ok) throw new Error('지역 데이터를 불러오는 데 실패했습니다.');
    const data = await response.json();

    // 각 지역별 세부지역 개수를 확인
    const regionsWithCounts = await Promise.all(
      data.map(async (region) => {
        const subRegionsResponse = await fetch(
          `/movieschedules/sub-regions?movieTitle=${encodeURIComponent(movieTitle)}&region=${encodeURIComponent(region)}&cinemaBrand=${cinemaBrand}`
        );
        const subRegionsData = await subRegionsResponse.json();
        return {
          region: region,
          count: subRegionsData.length
        };
      })
    );

    // count가 0인 지역은 필터링
    const filteredRegions = regionsWithCounts.filter(item => item.count > 0);
    setRegions(filteredRegions);

  } catch (error) {
    console.error('지역 데이터 가져오기 오류:', error);
  } finally {
    setLoadingStates(prev => ({ ...prev, regions: false }));
  }
};

const fetchSubRegions = async (movieTitle, region, cinemaBrand) => {
  console.log('=================================================');
  console.log('영화관', cinemaBrand);
  console.log('영화제목', movieTitle);
  console.log('지역', region);
  
  try {
      setLoadingStates(prev => ({ ...prev, subRegions: true }));
      const response = await fetch(
          `/movieschedules/sub-regions?movieTitle=${encodeURIComponent(movieTitle)}&region=${encodeURIComponent(region)}&cinemaBrand=${cinemaBrand}`
      );
      
      if (!response.ok) throw new Error('세부 지역 데이터를 불러오는 데 실패했습니다.');
      const data = await response.json();

      // 이미 백엔드에서 필터링된 데이터가 오므로 추가 필터링 불필요
      setSubRegions(data);
      
  } catch (error) {
      console.error('세부 지역 데이터 가져오기 오류:', error);
  } finally {
      setLoadingStates(prev => ({ ...prev, subRegions: false }));
  }
};

  
const fetchTheaters = async (movieTitle, region, subRegion, cinemaBrand) => {
  try {
      setLoadingStates(prev => ({ ...prev, theaters: true }));
      const response = await fetch(
          `/movieschedules/theaters?movieTitle=${encodeURIComponent(movieTitle)}&region=${encodeURIComponent(region)}&subRegion=${encodeURIComponent(subRegion)}&cinemaBrand=${cinemaBrand}`
      );
      
      if (!response.ok) throw new Error('상영관 데이터를 불러오는 데 실패했습니다.');
      const data = await response.json();

      // 이미 백엔드에서 필터링된 데이터가 오므로 추가 필터링 불필요
      setTheaters(data);
      
  } catch (error) {
      console.error('상영관 데이터 가져오기 오류:', error);
  } finally {
      setLoadingStates(prev => ({ ...prev, theaters: false }));
  }
};

const fetchDates = async (movieTitle, region, subRegion, theater) => {
  try {
    const response = await fetch(
      `/movieschedules/dates?movieTitle=${encodeURIComponent(movieTitle)}&region=${encodeURIComponent(region)}&subRegion=${encodeURIComponent(subRegion)}&theater=${encodeURIComponent(theater)}`
    );
    
    if (!response.ok) throw new Error('날짜 데이터를 불러오는 데 실패했습니다.');
    const data = await response.json();
    
    // 백엔드에서 이미 필터링된 날짜를 받으므로 그대로 설정
    setDates(data);
  } catch (error) {
    console.error('날짜 데이터 가져오기 오류:', error);
  }
};


const fetchTimes = async (movieTitle, region, subRegion, theater, date) => {
  try {
    const response = await fetch(
      `/movieschedules/times?movieTitle=${encodeURIComponent(movieTitle)}&region=${encodeURIComponent(region)}&subRegion=${encodeURIComponent(subRegion)}&theater=${encodeURIComponent(theater)}&date=${encodeURIComponent(date)}`
    );
    if (!response.ok) throw new Error('시간 데이터를 불러오는 데 실패했습니다.');
    const data = await response.json();

    // 당일예매가능여부는 이제 Calendar에서 처리하므로 이 체크는 제거
    setTimes(data);
  } catch (error) {
    console.error('시간 데이터 가져오기 오류:', error);
  }
};

  // menu_id가 설정되었을 때 스케줄 데이터 불러오기
  useEffect(() => {
    if (filters.menu_id) {
      fetchSchedule();
    }
  }, [filters.menu_id]);

  // 현재 날짜 업데이트
  useEffect(() => {
    setCurrentDate(DateTime.now());
  }, []);
  // 영화 데이터 불러오기 (자식 데이터 개수 포함)
  
  // 예매하기 버튼 클릭 핸들러
  const handleProceedToOrder = async () => {
    try {
      const response = await fetch(`/movieschedules/schedule/${filters.menu_id}`);
      if (!response.ok) throw new Error('일정 데이터를 불러오는 데 실패했습니다.');
      const data = await response.json();
      setSelectedSchedule(data);
      setShowModal(true);
    } catch (error) {
      console.error('일정 데이터 가져오기 오류:', error);
    }
  };
  // 선택된 시간에 대한 상영 일정 데이터 불러오기
  const fetchSchedule = async () => {
    try {
      const response = await fetch(`/movieschedules/schedule/${filters.menu_id}`);
      if (!response.ok) throw new Error('일정 데이터를 불러오는 데 실패했습니다.');
      const data = await response.json();
      //setShowModal(true); // 일정 선택 시 모달 표시
    } catch (error) {
      console.error('일정 데이터 가져오기 오류:', error);
    }
  };

  // 메인 변경 핸들러
  const handleChange = async (name, value) => {
    // 먼저 새로운 filters 객체를 만듭니다
    const newFilters = {
      ...filters,
      [name]: value,
      ...(name === 'cinemaBrand' && {
        movieTitle: '', region: '', subRegion: '', theater: '', date: '', time: '', menu_id: ''
      }),
      ...(name === 'movieTitle' && {
        region: '', subRegion: '', theater: '', date: '', time: '', menu_id: ''
      }),
      ...(name === 'region' && {
        subRegion: '', theater: '', date: '', time: '', menu_id: ''
      }),
      ...(name === 'subRegion' && {
        theater: '', date: '', time: '', menu_id: ''
      }),
      ...(name === 'theater' && {
        date: '', time: '', menu_id: ''
      }),
      ...(name === 'date' && {
        time: '', menu_id: ''
      })
    };
    
    // filters 상태를 업데이트
    setFilters(newFilters);
  
    try {
      switch(name) {
        case 'cinemaBrand':
          await fetchMovies(value);
          break;
        case 'movieTitle':
          await fetchRegions(value, newFilters.cinemaBrand);
          break;
        case 'region':
          await fetchSubRegions(newFilters.movieTitle, value, newFilters.cinemaBrand);
          break;
        case 'subRegion':
          await fetchTheaters(newFilters.movieTitle, newFilters.region, value, newFilters.cinemaBrand);
          break;
        case 'theater':
          await fetchDates(newFilters.movieTitle, newFilters.region, newFilters.subRegion, value);
          break;
        case 'date':
          await fetchTimes(newFilters.movieTitle, newFilters.region, newFilters.subRegion, newFilters.theater, value);
          break;
      }
    } catch (error) {
      console.error(`${name} 처리 중 오류:`, error);
    }
  };
  // 시간 선택 핸들러
  const handleTimeSelect = (menu_id, screening_time) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      time: screening_time,
      menu_id: menu_id, // 선택한 menu_id를 저장합니다.
    }));
  };
  const handleViewerCountChange = (e) => {
    const count = Number(e.target.value);
    setViewerCount(count);
    const newAmount = couponPrices[`${count}인`] || 0;
    setAmount(newAmount);
  };

  return (
    <>
      <Container>
        <Column>
          <Title>영화선택</Title>
          <Select
            name="cinemaBrand"
            value={filters.cinemaBrand}
            onChange={(e) => handleChange('cinemaBrand', e.target.value)}
          >
            <option value="">영화관 선택</option>
            <option value="CGV">CGV</option>
            <option value="메가박스">메가박스</option>
            <option value="롯데시네마">롯데시네마</option>
          </Select>
          
          {filters.cinemaBrand && (
            <SelectWrapper>
              <Select
                name="movieTitle"
                value={filters.movieTitle}
                onChange={(e) => handleChange('movieTitle', e.target.value)}
                disabled={loadingStates.movies}
              >
                <option value="">영화 선택</option>
                {movies.map((movie, index) => (
                  <option key={index} value={movie.movieTitle}>
                    {movie.movieTitle} ({movie.count})
                  </option>
                ))}
              </Select>
              {loadingStates.movies && <LoadingSpinner />}
            </SelectWrapper>
          )}
        </Column>

        {filters.movieTitle && (
          <Column>
            <SelectWrapper>
              <Select
                name="region"
                value={filters.region}
                onChange={(e) => handleChange('region', e.target.value)}
                disabled={loadingStates.regions}
              >
                <option value="">지역 선택</option>
                {regions.map((region, index) => (
                  <option key={index} value={region.region}>
                    {region.region} ({region.count})
                  </option>
                ))}
              </Select>
              {loadingStates.regions && <LoadingSpinner />}
            </SelectWrapper>

            {filters.region && (
              <SelectWrapper>
                <Select
                  name="subRegion"
                  value={filters.subRegion}
                  onChange={(e) => handleChange('subRegion', e.target.value)}
                  disabled={loadingStates.subRegions}
                >
                  <option value="">세부지역 선택</option>
                  {subRegions.map((subRegion, index) => (
                    <option key={index} value={subRegion.subRegion}>
                      {subRegion.subRegion} ({subRegion.count})
                    </option>
                  ))}
                </Select>
                {loadingStates.subRegions && <LoadingSpinner />}
              </SelectWrapper>
            )}

            {filters.subRegion && (
              <SelectWrapper>
                <Select
                  name="theater"
                  value={filters.theater}
                  onChange={(e) => handleChange('theater', e.target.value)}
                  disabled={loadingStates.theaters}
                >
                  <option value="">상영관 선택</option>
                  {theaters.map((theater, index) => (
                    <option key={index} value={theater.theater}>
                      {theater.theater} ({theater.count})
                    </option>
                  ))}
                </Select>
                {loadingStates.theaters && <LoadingSpinner />}
              </SelectWrapper>
            )}
          </Column>
        )}

      {filters.theater && (
        <Column>
          <Title>일정선택</Title>
          <Calendar
            onChange={(date) => {
              const now = DateTime.now().setZone('Asia/Seoul');
              const selectedDate = DateTime.fromJSDate(date);
              const isToday = selectedDate.hasSame(now, 'day');
              const todayBooking = String(applyCurrentCoupon.today_booking).toLowerCase();

              if (isToday && todayBooking !== 'true') {
                alert('당일 예매가 불가능한 상품입니다.');
                return;
              }

              handleChange('date', selectedDate.toISODate());
            }}
            value={filters.date ? new Date(filters.date) : new Date()}
            minDate={DateTime.now().toJSDate()}
            tileDisabled={({ date }) => {
              const dateStr = DateTime.fromJSDate(date).toISODate();
              const isDateAvailable = dates.includes(dateStr);

              // 당일예매가능여부 체크
              const now = DateTime.now().setZone('Asia/Seoul');
              const checkDate = DateTime.fromJSDate(date);
              const isToday = checkDate.hasSame(now, 'day');

              // String()으로 변환 후 소문자로 변환하여 대소문자 무시 비교
              const todayBooking = String(applyCurrentCoupon.today_booking).toLowerCase();
              const isTodayDisabled = todayBooking !== 'true' && isToday;

              if (isToday) {
                console.log('[디버그] today_booking:', JSON.stringify(applyCurrentCoupon.today_booking), 'type:', typeof applyCurrentCoupon.today_booking, 'todayBooking(String):', todayBooking, 'isTodayDisabled:', isTodayDisabled);
              }

              return !isDateAvailable || isTodayDisabled;
            }}
          />
          
          {filters.date && (
            <>
              <Title>시간선택</Title>
              <ButtonList>
                {times.map((time, index) => {
                  const limitHours = 3;
                  const now = DateTime.now().setZone('Asia/Seoul');
                  const selectedDate = DateTime.fromISO(filters.date);
                  const isToday = selectedDate.hasSame(now, 'day');
                  const oneHourLater = now.plus({ hours: limitHours }).toFormat('HH:mm');
                  const isNearTime = isToday && time.screening_time <= oneHourLater;
                  
                  return (
                    <TimeButton
                      key={index}
                      selected={filters.time === time.screening_time}
                      onClick={() => {
                        if (isNearTime) {
                          alert(`상영시간 ${limitHours}시간 전 영화는 예매하실 수 없습니다.`);
                          return;
                        }
                        handleTimeSelect(time.menu_id, time.screening_time);
                      }}
                      style={isNearTime ? {
                        backgroundColor: '#e0e0e0',
                        cursor: 'not-allowed'
                      } : {}}
                      title={isNearTime ? '상영 시작 시간 3시간 이내 상품은 선택이 불가능합니다.' : ''}
                    >
                      {time.screening_time}
                    </TimeButton>
                  );
                })}
              </ButtonList>
            </>
          )}
        </Column>
      )}

        {filters.time && (
          <Column>
            <Title>관람 인원 및 금액</Title>
            <Select id="viewerCount" value={viewerCount} onChange={handleViewerCountChange}>
              {[1, 2, 3, 4, 5, 6].map((count) => (
                count >= applyCurrentCoupon.min_order_cnt && count <= applyCurrentCoupon.max_order_cnt ?
                <option key={count} value={count}>{count}명</option> : null
              ))}
            </Select>
            <div>예매인원 제한 {applyCurrentCoupon.min_order_cnt} ~ {applyCurrentCoupon.max_order_cnt}</div>
            <Title>금액</Title>
            <Input type="text" value={`₩${amount.toLocaleString('ko-KR')}`}  disabled />
            <Button onClick={handleProceedToOrder}>예매하기</Button>
          </Column>
        )}
      </Container>

      {showModal && selectedSchedule && (
        <OrderFormModal
          onClose={() => {
            clearCouponCookie();
            setShowScheduleFilter(false);
            setShowModal(false);
          }}
          movieInfo={{
            ...selectedSchedule,
            screeningRoom: `${selectedSchedule.theater} ${selectedSchedule.screening_place}`,
            startTime: filters.time,
            cinemaBrand: filters.cinemaBrand,
          }}
          movieViewerCount={viewerCount}
          totalAmount={amount}
        />
      )}
    </>
  );
};

export default MovieScheduleFilter;